
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkItemLinkedItemsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkItem"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"widgets"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkItemWidgetLinkedItems"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkedItems"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workItemState"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workItem"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"confidential"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"namespace"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullPath"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"workItemType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iconName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"closedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"webUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"full"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widgets"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkItemWidgetLinkedItems"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedItems"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkType"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkItemMetadataWidgets"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkItemMetadataWidgetsExtras"},"directives":[]}]}}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1495}};
    doc.loc.source = {"body":"#import \"ee_else_ce/work_items/graphql/work_item_metadata_widgets.fragment.graphql\"\n#import \"ee_else_ce/work_items/graphql/work_item_metadata_widgets_extras.fragment.graphql\"\n\n# @graphql-eslint/eslint-plugin@4.0.0 reports missing IDs in `FragmentDefinition`. For now, we are\n# ignoring the newly uncovered error on this fragment. Please consider addressing the violation\n# if you are modifying this file and it turns out selecting the ID makes sense here.\n# eslint-disable-next-line @graphql-eslint/require-selections\nfragment WorkItemLinkedItemsFragment on WorkItem {\n  widgets {\n    ... on WorkItemWidgetLinkedItems {\n      type\n      linkedItems {\n        nodes {\n          linkId\n          linkType\n          workItemState\n          workItem {\n            id\n            iid\n            confidential\n            namespace {\n              id\n              fullPath\n            }\n            workItemType {\n              id\n              name\n              iconName\n            }\n            title\n            state\n            createdAt\n            closedAt\n            webUrl\n            reference(full: true)\n            widgets {\n              ... on WorkItemWidgetLinkedItems {\n                linkedItems {\n                  nodes {\n                    linkId\n                    linkType\n                  }\n                }\n              }\n              ...WorkItemMetadataWidgets\n              ...WorkItemMetadataWidgetsExtras\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("ee_else_ce/work_items/graphql/work_item_metadata_widgets.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("ee_else_ce/work_items/graphql/work_item_metadata_widgets_extras.fragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["WorkItemLinkedItemsFragment"] = oneQuery(doc, "WorkItemLinkedItemsFragment");
        
